/*
    Calculette taux endettement

    issue de lpi ancienne génération
*/
$ = jQuery;

  function lpi_init_calcTauxDete() {
    console.log('lpi_init_calcTauxDete()');
    hide("RevenusSuiteRow");
    hide("AchatResidenceRow");
    hide("RevenusTable");
    hide("ChargesTable");
    hide("TotalLocationRow");
    hide("FormLink");
    hide("resultBox");
    show("CalculatorForm");

    var revenus_fonciers = document.getElementById("revenus_fonciers").value;
    var revenus_suite = document.getElementById("revenus_suite").value;
    var achat_residence = document.getElementById("achat_residence").value;

    /* Affiche les questions + tableaux (+ certaines lignes) en fonction
     * des réponses aux questions */
    if(revenus_fonciers == "non"){
      show("RevenusTable");
      show("ChargesTable");
    } else if(revenus_fonciers == "oui"){
      show("RevenusSuiteRow");
      if (revenus_suite == "oui"){
        show("RevenusTable");
        show("ChargesTable");
        show("TotalLocationRow");
      } else if(revenus_suite == "non"){
        show("AchatResidenceRow");
        if(achat_residence == "oui"){
          show("RevenusTable");
          show("ChargesTable");
        } else if(achat_residence == "non"){
          show("RevenusTable");
          show("ChargesTable");
          show("TotalLocationRow");
        }
      }
    } else {
       revenus_suite = "";
       achat_residence = "";
       /* vider tout les champs */
    }

    /* Reinitialise certains éléments */
    document.getElementById("loyers_ponderes").innerHTML = "";
    return false;
  }

  function lpi_calcul_calcTauxDete() {
    console.log('lpi_calcul_calcTauxDete()');
    lpi_init_calcTauxDete();

    /* Récupération des données du formulaire
     * Attention : multiplication par 1 pour forcer en nombre */

    /* variables questions */
    var revenus_fonciers = document.getElementById("revenus_fonciers").value;
    var revenus_suite = document.getElementById("revenus_suite").value;
    var achat_residence = document.getElementById("achat_residence").value;

    /* variables revenus */
    var salaire_emprunteur = formatFloat(document.getElementById("salaire_emprunteur").value, ".") * 1;
    var salaire_conjoint = formatFloat(document.getElementById("salaire_conjoint").value, ".") * 1;
    var mois_emprunteur = formatFloat(document.getElementById("mois_emprunteur").value, ".") * 1;
    var mois_conjoint = formatFloat(document.getElementById("mois_conjoint").value, ".") * 1;
    var autres_revenus = formatFloat(document.getElementById("autres_revenus").value, ".") * 1;
    var loyers_bruts = formatFloat(document.getElementById("loyers_bruts").value, ".") * 1;
    var allocations = formatFloat(document.getElementById("allocations").value, ".") * 1;

    /* variables charges */
    var charge_loyer = formatFloat(document.getElementById("charge_loyer").value, ".") * 1;
    var echeance_residence_1 = formatFloat(document.getElementById("echeance_residence_1").value, ".") * 1;
    var echeance_residence_2 = formatFloat(document.getElementById("echeance_residence_2").value, ".") * 1;
    var echeance_location = formatFloat(document.getElementById("echeance_location").value, ".") * 1;
    var credit_conso = formatFloat(document.getElementById("credit_conso").value, ".") * 1;
    var credit_voiture = formatFloat(document.getElementById("credit_voiture").value, ".") * 1;
    var credit_travaux = formatFloat(document.getElementById("credit_travaux").value, ".") * 1;
    var credit_autres = formatFloat(document.getElementById("credit_autres").value, ".") * 1;
    var pensions_alimentaires = formatFloat(document.getElementById("pensions_alimentaires").value, ".") * 1;
    var charges_diverses = formatFloat(document.getElementById("charges_diverses").value, ".") * 1;


    var loyers_ponderes = loyers_bruts * 0.8;
    if (!empty(loyers_bruts) && !isNaN(loyers_bruts))
      document.getElementById("loyers_ponderes").innerHTML = formatFloat(format(loyers_ponderes, 2, " "), ",") + " &euro;";

    var total_revenus = 0;
    total_revenus = (salaire_emprunteur * mois_emprunteur)/12 + (salaire_conjoint * mois_conjoint)/12;
    total_revenus += autres_revenus / 12 + allocations;

    var total_charges = 0;
    total_charges = charge_loyer + echeance_residence_1 + echeance_residence_2 + credit_conso;
    total_charges += credit_voiture + credit_travaux + credit_autres + pensions_alimentaires + charges_diverses;

    /* Cas 1 */
    if(revenus_fonciers == "non" || (revenus_suite == "non" && achat_residence == "oui")){
      total_revenus += loyers_ponderes;
      total_charges += echeance_location;

    /* Cas 2 */
    } else if(revenus_fonciers == "oui" && (revenus_suite == "oui" || (revenus_suite == "non" && achat_residence == "non"))){
      var total_location = echeance_location - loyers_ponderes;
      document.getElementById("total_location").innerHTML = formatFloat(format(total_location, 2, " "), ",") + " &euro;";
      total_charges += total_location;
    }

    document.getElementById("total_revenus").innerHTML = formatFloat(format(total_revenus, 2, " "), ",") + " &euro;";
    document.getElementById("total_charges").innerHTML = formatFloat(format(total_charges, 2, " "), ",") + " &euro;";

    var taux_endettement = (total_revenus == 0) ? 0 : total_charges / total_revenus * 100;
    document.getElementById("taux_endettement").innerHTML = formatFloat(format(taux_endettement, 2, " "), ",") + " %";

    var vivre_mensuel = total_revenus - total_charges;
    document.getElementById("vivre_mensuel").innerHTML = formatFloat(format(vivre_mensuel, 2, " "), ",") + " &euro;";

    var vivre_personne = (salaire_conjoint == 0) ? vivre_mensuel : vivre_mensuel / 2;
    document.getElementById("vivre_personne").innerHTML = formatFloat(format(vivre_personne, 2, " "), ",") + " &euro;";

    // $('.sfi-calc--resultat').css('display', 'block');
    jQuery( document.body ).trigger( 'post-load' ); // refresh de la page
    return false;
  }
  function lpi_submit_calcTauxDete() {
    console.log('lpi_submit_calcTauxDete()');
    lpi_calcul_calcTauxDete();
    show('FormLink');show('resultBox');

    console.log('Endettement ok');

    gtag('event', 'submit', {
      'send_to' : 'UA-122662450-4',
      'event_category' : 'Calculette capacite d\'endettement'
    });
    $('.sfi-calc--resultat').css('display', 'block');
    jQuery( document.body ).trigger( 'post-load' );
    return false;
  }

jQuery(function($){
  if($('#RevenusSuiteRow').length >0 )
    lpi_init_calcTauxDete();
});
